import { render, staticRenderFns } from "./SwCheckbox.vue?vue&type=template&id=d5aae68a"
import script from "./SwCheckbox.vue?vue&type=script&lang=js"
export * from "./SwCheckbox.vue?vue&type=script&lang=js"
import style0 from "./SwCheckbox.vue?vue&type=style&index=0&id=d5aae68a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports